var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { "padding-top": "50px" },
              attrs: { dense: "", extended: "", color: "primary", dark: "" },
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "pa-5": "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "display-2",
                      attrs: { slot: "extension" },
                      slot: "extension",
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-bottom": "10px" },
                          attrs: { "x-large": "" },
                        },
                        [_vm._v("cloud_sync")]
                      ),
                      _vm._v(
                        "\n          Continuous Data Ingestion Management\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n        Manage configurations, schedules, job runs, and photo uploads.\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs6: "", sm3: "", "pa-1": "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { color: "primary", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ name: "ingestionConfigs" })
                        },
                      },
                    },
                    [
                      _c("v-card-text", { staticClass: "text-xs-center" }, [
                        _c("div", { staticClass: "display-1" }, [
                          _vm._v(_vm._s(_vm.configCount)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "caption" }, [
                          _vm._v("Configurations"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "", sm3: "", "pa-1": "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { color: "info", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "ingestionSchedules",
                          })
                        },
                      },
                    },
                    [
                      _c("v-card-text", { staticClass: "text-xs-center" }, [
                        _c("div", { staticClass: "display-1" }, [
                          _vm._v(_vm._s(_vm.scheduleCount)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "caption" }, [
                          _vm._v("Schedules"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "", sm3: "", "pa-1": "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { color: "success", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "ingestionJobs",
                            query: { from: _vm.todayISO },
                          })
                        },
                      },
                    },
                    [
                      _c("v-card-text", { staticClass: "text-xs-center" }, [
                        _c("div", { staticClass: "display-1" }, [
                          _vm._v(_vm._s(_vm.jobsToday)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "caption" }, [
                          _vm._v("Jobs Today"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "", sm3: "", "pa-1": "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { color: "warning", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ name: "ingestionJobs" })
                        },
                      },
                    },
                    [
                      _c("v-card-text", { staticClass: "text-xs-center" }, [
                        _c("div", { staticClass: "display-1" }, [
                          _vm._v(_vm._s(_vm.runningJobs)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "caption" }, [
                          _vm._v("Running / Queued"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md3: "", "pa-1": "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { hover: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ name: "ingestionConfigs" })
                        },
                      },
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { large: "", color: "primary" } },
                            [_vm._v("settings")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "subheading mt-2" }, [
                            _vm._v("Configurations"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "caption grey--text" }, [
                            _vm._v("Manage ingestion and photo configs"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md3: "", "pa-1": "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { hover: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "ingestionSchedules",
                          })
                        },
                      },
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { large: "", color: "info" } },
                            [_vm._v("schedule")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "subheading mt-2" }, [
                            _vm._v("Schedules"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "caption grey--text" }, [
                            _vm._v("Manage cron schedules and assignments"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md3: "", "pa-1": "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { hover: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ name: "ingestionJobs" })
                        },
                      },
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { large: "", color: "success" } },
                            [_vm._v("history")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "subheading mt-2" }, [
                            _vm._v("Job Runs"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "caption grey--text" }, [
                            _vm._v("View job history and results"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md3: "", "pa-1": "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { hover: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "ingestionPhotoUpload",
                          })
                        },
                      },
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { large: "", color: "warning" } },
                            [_vm._v("add_a_photo")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "subheading mt-2" }, [
                            _vm._v("Photo Upload"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "caption grey--text" }, [
                            _vm._v("Upload station photos"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "text-xs-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        large: "",
                        color: "primary",
                        dark: "",
                        loading: _vm.triggering,
                      },
                      on: { click: _vm.triggerAll },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("play_arrow"),
                      ]),
                      _vm._v("Trigger All Active Configurations\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.triggerResult
                    ? _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-chip",
                            { attrs: { color: "success", dark: "" } },
                            [
                              _vm._v(
                                "Batch: " + _vm._s(_vm.triggerResult.BatchId)
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-chip", { attrs: { color: "info", dark: "" } }, [
                            _vm._v(
                              _vm._s(_vm.triggerResult.JobRunIds.length) +
                                " jobs created"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", [_vm._v("Recent Job Runs")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        color: "info",
                        to: { name: "ingestionJobs" },
                      },
                    },
                    [_vm._v("View All")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.jobHeaders,
                  items: _vm.recentJobs,
                  loading: _vm.jobsLoading,
                  "hide-actions": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "max-width": "120px",
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                            },
                            attrs: { title: props.item.Id },
                          },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: `/administration/ingestion-jobs/${props.item.Id}`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.shorten(props.item.Id)) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            props.item.ConfigurationId
                              ? _c(
                                  "router-link",
                                  {
                                    attrs: { to: { name: "ingestionConfigs" } },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.configName(
                                            props.item.ConfigurationId
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _c("span", [_vm._v("-")]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  color: _vm.statusColor(props.item.Status),
                                  small: "",
                                  dark: "",
                                },
                              },
                              [_vm._v(_vm._s(props.item.Status))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatDate(props.item.StartedAt))),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.formatDuration(props.item.DurationSeconds)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  color: "info",
                                  depressed: "",
                                  to: `/administration/ingestion-jobs/${props.item.Id}`,
                                },
                              },
                              [_vm._v("View")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackColor, timeout: 6000, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function ($event) {
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }